// Types
import { EquipmentUnitDataVSICrusher } from '../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../types/global';

export enum VSIDrawerType {
  feeder = 'feeder',
  lidStatus = 'lidStatus',
  lubricationUnit = 'lubricationUnit',
  motorControl = 'motorControl',
  motorStatus = 'motorStatus',
}

export interface DrawersProps {
  alertText?: string | null;
  className?: string;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  equipmentUnitId: string;
  isDrawerOpen: boolean;
  lastLidOpenedAt?: number | null;
  onCloseDrawer: () => void;
  selectedDrawer: VSIDrawerType | null;
  testId?: string;
  unitData: EquipmentUnitDataVSICrusher | null;
}

export interface DrawerContentProps {
  edgeStatus: EdgeDeviceOperationalStatus | null;
  testId?: string;
  equipmentUnitId: string;
  lastLidOpenedAt?: number | null;
  unitData: EquipmentUnitDataVSICrusher | null;
}
